import { connect } from "react-redux";

import { CandyDispatch, CandyThunkAction } from "../../../Engine/Core/Store/CandyReduxTypes";
import { formSendAction } from "../../../Engine/ActionCreators/FormActionCreators";

import { SendActionButton } from "./SendActionButton";

export function validateBeforeSend(): CandyThunkAction<Promise<boolean>> {
    return async (_, __, form: IForm) => {
        await form.publicForm.validate();
        const withInvalidControls = await form.focusFirstInvalidControl();
        return withInvalidControls;
    };
}

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onSendForm: () => dispatch(formSendAction),
    localValidationBeforeSend: () => dispatch(validateBeforeSend()),
});

export const SendActionButtonContainer = connect(undefined, mapDispatchToProps)(SendActionButton);
